import {initSlider} from './initSlider';
import {initToolTipToggler} from './toggleTooltip';
import {initTabs} from './initTabs';
import {trigger} from '../../../utils/events/trigger';
import {initMovingLine} from '../../common/moving-line';

export const initSectionCds2SliderWithTooltips = () => {
	const components = document.querySelectorAll( 'section.cds2-slider-with-tooltips' );

	if ( components.length )
	{
		components.forEach( ( component ) => {
			const tabsContainer = component.querySelector( 'div.tabs' );
			const sliders = Array.from( component.querySelectorAll( 'div.new-slider' ) );
			const slidersSplit = [];

			sliders.forEach( ( slider ) => {
				const updateSlider = initSlider( slider );
				
				slider.classList.remove( 'not-init' );
				
				slidersSplit.push( {slider, updateSlider} );
			} );

			initToolTipToggler( component );
			
			initTabs( tabsContainer, slidersSplit );
			
			if ( tabsContainer )
			{
				const tabsList = tabsContainer.querySelector( 'ul' );
				
				if ( tabsList )
				{
					initMovingLine( tabsContainer, tabsList, {animDuration: 200} );
				}
			}
		} );
	}

	const apartmentCard = document.querySelector( 'article.cds2-apartment-card' );
	const finishingList = document.querySelector( 'article.cds2-apartment-card ul.finishing' );
	const finishingButtons = document.querySelectorAll( 'section.cds2-slider-with-tooltips.finishing button' );

	if ( apartmentCard && finishingButtons.length )
	{
		Array.from( finishingButtons ).forEach( ( it ) => {
			it.addEventListener( 'click', ( evt ) => {
				evt.preventDefault();

				const requestedInput = finishingList.querySelector( `input[data-finishing="${it.dataset.finishing}"]` );
				
				trigger( requestedInput, 'change', true );

				const initialDistance = Math.round( apartmentCard.getBoundingClientRect().top - document.querySelector( 'header' ).offsetHeight - 20 );
				let closedDistance = 0;
		
				const pathInterval = setInterval( () => {
					const diff = initialDistance - closedDistance;
		
					if ( diff < 0 )
					{
						window.scrollBy( 0, diff < -50 ? -50 : diff );
						closedDistance -= 50;
					}
					else
					{
						clearInterval( pathInterval );
					}
				}, 10 );
			} );
		} );
	}
};
